import { render, staticRenderFns } from "./ReginScreen.vue?vue&type=template&id=b9fd578e&scoped=true"
import script from "./ReginScreen.vue?vue&type=script&lang=js"
export * from "./ReginScreen.vue?vue&type=script&lang=js"
import style0 from "./ReginScreen.vue?vue&type=style&index=0&id=b9fd578e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9fd578e",
  null
  
)

export default component.exports